import type {
  ListaItens,
  SeletorItem,
} from '@Lar21/imaginii-web-components/vue'
import { ref } from 'vue'

type OpcaoComId = Readonly<{ id: string }>
type Registro = Readonly<Record<string, unknown>>
const revisaoSelecaoNaoVazia = ref(0)

const ehRegistro = (valor: unknown): valor is Registro => (
  typeof valor === 'object' && valor !== null
)

const obterPrimeiroValor = (
  registro: Registro,
  chaves: readonly string[],
): unknown => chaves.map((chave) => registro[chave]).find((valor) => (
  typeof valor === 'string' || typeof valor === 'number'
))

const criarItensDaSelecao = (selecao: unknown): SeletorItem[] => {
  const opcoes = Array.isArray(selecao) ? selecao : (selecao ? [selecao] : [])
  return opcoes.flatMap((opcao) => {
    if (!ehRegistro(opcao)) return []
    const chave = obterPrimeiroValor(opcao, ['chave', 'id'])
    const valor = obterPrimeiroValor(
      opcao,
      ['valor', 'nome', 'name', 'descricao', 'description'],
    )
    if (
      (typeof chave !== 'string' && typeof chave !== 'number')
      || (typeof valor !== 'string' && typeof valor !== 'number')
    ) return []
    return [{ chave, valor: String(valor) }]
  })
}

export const prepararEstadoSomenteLeitura = (
  estado: ListaItens,
  somenteLeitura: boolean,
  selecaoOriginal?: unknown,
): ListaItens => {
  // Invalida os estados computados dos catálogos após uma limpeza rejeitada.
  // Isso ressincroniza a seleção local mantida pelo PontotelSeletor.
  void revisaoSelecaoNaoVazia.value
  if (!somenteLeitura) return estado
  const selecionados = selecaoOriginal === undefined
    ? estado.selecionados
    : criarItensDaSelecao(selecaoOriginal)
  return { carregados: selecionados, selecionados }
}

export const preservarEstadoSemSelecaoVazia = (
  novoEstado: ListaItens,
  estadoAtual: ListaItens,
  permiteLimpar: boolean,
): ListaItens => {
  const rejeitouSelecaoVazia = !permiteLimpar
    && novoEstado.selecionados.length === 0
    && estadoAtual.selecionados.length > 0
  if (rejeitouSelecaoVazia) revisaoSelecaoNaoVazia.value += 1
  return rejeitouSelecaoVazia ? estadoAtual : novoEstado
}

export const encontrarOpcaoDoCatalogo = <T extends OpcaoComId>(
  opcoes: readonly T[],
  item: SeletorItem,
): T | undefined => opcoes.find(({ id }) => id === String(item.chave))
